import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
// import InstagramLogo from "../../assets/images/instagram-logo.svg";
import {
  isAndroid,
  isDesktop,
  isIOS,
  isMacOs,
  isTablet,
} from 'react-device-detect';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
// import Lottie from 'react-lottie-player';
import AppleLogo from '../../assets/images/auth-apple-logo.svg';
import GoogleLogo from '../../assets/images/auth-google-logo.svg';
import NameLogo from '../../assets/images/auth-name-logo.svg';
import { layoutDefaults } from '../../utils/layout-defaults';
import { ModalBodyDivider } from '../modal/modal-body-divider';
// import { PrivacyNotice } from '../privacy-notice';
// import authIconData from './auth-icon.json';
import { OAuthAppleButton } from './oauth-apple-button';
import { OAuthGoogleButton } from './oauth-google-button';
import { OAuthNameButton } from './oauth-name-button';

// const animate = "animate__slow animate__shakeX animate__delay-1s";

function OAuthModalBody({
  analytics,
  // publicAPI,
  accountAPI,
  showNameParam,
  config,
  onLoggedIn,
  onErrorMessage,
  onShowWeakAuth,
}) {
  const { analyticsFeatureUseEvent, analyticsHelpEvent } = analytics;
  const [showWeakAuthOption, setShowWeakAuthOption] = useState(false);
  // const { getLoginPrivacyPolicyFromRemote } = publicAPI;
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (showWeakAuthOption) {
      analyticsFeatureUseEvent('auth naming open');
      onErrorMessage?.call(this, null, null);
    }
  }, [showWeakAuthOption]);

  const handleErrorMessage = (message, service) => {
    if (_.isEmpty(message)) {
      onErrorMessage?.call(this, message, service);
    } else if (showNameParam) {
      onErrorMessage?.call(this, null, service);
      analyticsHelpEvent('auth naming open');

      onShowWeakAuth?.call(this, true);

      _.delay(() => {
        setShowWeakAuthOption(true);
      }, 100);
    } else {
      onErrorMessage?.call(this, message, service);
      console.error(new Error(message));
    }
  };

  const onAuthHelpClick = () => {
    if (!showWeakAuthOption) {
      onShowWeakAuth?.call(this, true);
      _.delay(() => {
        setShowWeakAuthOption(true);
      }, 100);
    } else {
      setShowWeakAuthOption(false);

      _.delay(() => {
        onShowWeakAuth?.call(this, false);
      }, 300);
    }

    setShowWeakAuthOption(!showWeakAuthOption);
    analyticsFeatureUseEvent('auth help open');
  };

  return (
    <div className={classes.container}>
      {/* <div className={classes.header}>
        <Lottie
          play
          loop={false}
          animationData={authIconData}
          className={classes.icon}
        />
        <FadeIn>
          <div className={classes.title}>{t('oauth.who-are-you')}</div>
        </FadeIn>
      </div>

      <FadeIn delay={150}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getLoginPrivacyPolicyFromRemote}
        />
      </FadeIn> */}

      <div className={classes.buttons}>
        {(isIOS || isMacOs) && (
          <OAuthAppleButton
            logo={AppleLogo}
            analytics={analytics}
            accountAPI={accountAPI}
            config={config}
            onLoggedIn={onLoggedIn}
            onErrorMessage={handleErrorMessage}
          >
            {t(
              isDesktop ? 'oauth.button.apple.desktop' : 'oauth.button.apple',
              {
                appleOrIphone: isTablet ? 'Apple' : 'iPhone',
              }
            )}
          </OAuthAppleButton>
        )}

        <OAuthGoogleButton
          logo={GoogleLogo}
          analytics={analytics}
          accountAPI={accountAPI}
          config={config}
          onLoggedIn={onLoggedIn}
          onErrorMessage={handleErrorMessage}
        >
          {t(isAndroid ? 'oauth.button.google.android' : 'oauth.button.google')}
        </OAuthGoogleButton>
      </div>

      {showNameParam && (
        <>
          {showWeakAuthOption && (
            <FadeIn className={classes.weakAuthContainer}>
              <ModalBodyDivider title={t('divider.or')} />

              <OAuthNameButton
                logo={NameLogo}
                analytics={analytics}
                accountAPI={accountAPI}
                // config={config}
                onLoggedIn={onLoggedIn}
                onErrorMessage={onErrorMessage}
              >
                {t('oauth.button.with-name')}
              </OAuthNameButton>
            </FadeIn>
          )}

          {!showWeakAuthOption && (
            <div className={classes.help}>
              <span className={classes.helpText}>
                {t('oauth.have-difficulty')}
              </span>
              <Button
                variant="link"
                onClick={onAuthHelpClick}
                className={classes.link}
              >
                {t('oauth.button.weak-auth')}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: -layoutDefaults.bigVerticalMargin,
    // marginTop: -40,
    // border: '1px solid red',
  },
  // header: {
  //   // marginBottom: layoutDefaults.verticalMargin,
  // },
  // icon: {
  //   height: 120,
  // },
  // title: {
  //   fontSize: layoutDefaults.biggestFontSize,
  //   fontWeight: 'bold',
  //   marginTop: layoutDefaults.smallerVerticalMargin,
  // },
  // subTitle: {
  //   fontSize: layoutDefaults.fontSize,
  // },
  buttons: {
    marginTop: layoutDefaults.verticalMargin,
  },
  // privacyContainer: {},
  // privacy: {
  //   color: '#888',
  //   textAlign: 'left',
  //   backgroundColor: '#f9f9f9',
  //   paddingLeft: layoutDefaults.horizontalMargin,
  //   paddingRight: layoutDefaults.horizontalMargin,
  //   paddingTop: layoutDefaults.verticalMargin,
  //   border: '1px #aaa dashed',
  //   borderRadius: layoutDefaults.radius,
  //   marginTop: layoutDefaults.verticalMargin,
  //   marginBottom: layoutDefaults.verticalMargin,
  // },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.linkColor,
    marginLeft: layoutDefaults.smallestHorizontalMargin,
    padding: 0,
    margin: 0,
  },
  // footer: {
  //   textAlign: 'right',
  // },
  emphasis: {
    color: 'black',
  },
  manualButton: {
    width: '100%',
  },
  weakAuthContainer: {
    marginBottom: layoutDefaults.bigVerticalMargin,
  },
  help: {
    fontSize: layoutDefaults.fontSize,
    marginTop: layoutDefaults.biggerVerticalMargin,
    marginBottom: 0,
  },
  helpText: {
    paddingRight: layoutDefaults.smallestHorizontalMargin,
    opacity: layoutDefaults.opacity,
  },
});

export { OAuthModalBody };
